module.exports = __webpack_public_path__ + "resources/img/sp_service.783e1ecee22126b28c166b55a765d157.png";